var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgWowlabzlogo3X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88242 0H0L5.89243 21.2252H11.7748L5.88242 0Z",
    fill: "#1CADE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25543 8.54846L5.90295 21.2263H11.7748L8.25543 8.54846Z",
    fill: "#008CB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4503 0H23.5681L19.6385 14.1554H25.521L29.4503 0Z",
    fill: "#1CADE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6776 0H11.7952L5.90295 21.2252H11.7854L17.6776 0Z",
    fill: "#1CADE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1144 15.6201H19.232L17.6757 21.2267H23.5581L25.1144 15.6201Z",
    fill: "#1CADE3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7954 0L11.7819 0.0488117L14.1385 12.7498L17.6778 0H11.7954Z",
    fill: "#008CB7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9014 0H11.7729L17.1337 18.9881L20.1979 8.13433L17.9014 0Z",
    fill: "#1CADE3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgWowlabzlogo3X);
export default __webpack_public_path__ + "static/media/img_wowlabz logo@3x.837ec64c8dedc09afd3e2b59108ad46e.svg";
export { ForwardRef as ReactComponent };